// Full-size view of one image in a dismissable modal (close button, backdrop
// click, or Escape). Shown whenever `src` is non-null. Optional `actions` are
// rendered in a footer under the image (e.g. "Use as preview image").

import { Modal } from "react-bootstrap";

type ImagePreviewModalProps = {
  src: string | null;
  alt: string;
  onHide: () => void;
  actions?: React.ReactNode;
};

const ImagePreviewModal = ({ src, alt, onHide, actions }: ImagePreviewModalProps) => (
  <Modal show={src !== null} onHide={onHide} centered size="lg" aria-label="Image preview">
    <Modal.Header closeButton closeLabel="Close image preview" />
    <Modal.Body className="p-0 text-center bg-dark">
      {src && <img src={src} alt={alt} className="imagePreviewModalImg" data-testid="image-preview" />}
    </Modal.Body>
    {actions && <Modal.Footer>{actions}</Modal.Footer>}
  </Modal>
);

export default ImagePreviewModal;
